import type { FlavorConfig } from '../types';

/**
 * Flavor B Configuration
 * Alternative design with Kapital-specific branding
 */
export const flavorBConfig: FlavorConfig = {
  id: 'B',
  name: 'Flavor B - Kapital',
  className: 'flavor-b',
  description: 'Kapital-specific design with compact layout and custom branding',
  styles: {
    borderRadius: '6px',
    cardBackground: '#f7f7f7',
    popupBackground: 'var(--gradient-card)',
    iconBackground: 'transparent',
  },
};

export default flavorBConfig;
